import React from 'react';

import { Accordion } from 'react-bootstrap';

import 'components/GMetrixAccordion/gmetrix-accordion.scss';

type GMetrixAccordionProps = {
    alwaysOpen?: boolean;
    children?: React.ReactNode;
    className?: string;
    defaultActiveKey?: string | string[];
};

export const GMetrixAccordion = (props: GMetrixAccordionProps) => {

    const { alwaysOpen = true, children, className = '', defaultActiveKey } = props;

    const flatChildren = React.Children.toArray(children);
    const computedDefaultKeys: string[] = [];
    let autoIndex = 0;

    const processedChildren = flatChildren.map(child => {

        if (!React.isValidElement(child)) return child;

        const childProps = child.props as Record<string, unknown>;
        const eventKey = (childProps.eventKey as string) || autoIndex.toString();
        autoIndex++;

        if (childProps.expanded === true) {

            computedDefaultKeys.push(eventKey);

        }

        return React.cloneElement(child as React.ReactElement, { eventKey });

    });

    const activeKeys = defaultActiveKey !== undefined ? defaultActiveKey : computedDefaultKeys;

    return (
        <Accordion
            alwaysOpen={alwaysOpen}
            className={`gmetrix-accordion ${className}`}
            defaultActiveKey={activeKeys}
        >
            {processedChildren}
        </Accordion>
    );

};

type GMetrixAccordionItemProps = {
    bordered?: boolean;
    children?: React.ReactNode;
    className?: string;
    eventKey?: string;
    expanded?: boolean;
    headerClassName?: string;
    title: string | React.ReactNode;
};

export const GMetrixAccordionItem = (props: GMetrixAccordionItemProps) => {

    const { bordered = false, children, className = '', eventKey = '0', headerClassName = '', title } = props;

    const hasContent = React.Children.count(children) > 0;

    return hasContent ? (
        <Accordion.Item className={`${bordered ? 'gmetrix-accordion-item--bordered' : ''} ${className}`} eventKey={eventKey}>
            <Accordion.Header className={headerClassName}>
                {title}
            </Accordion.Header>
            <Accordion.Body>
                {children}
            </Accordion.Body>
        </Accordion.Item>
    ) : (
        <div className={`gmetrix-accordion-item--static ${className}`}>
            <div className={`gmetrix-accordion-item__header ${headerClassName}`}>
                {title}
            </div>
        </div>
    );

};
